// Shared date helpers for calendar dates ("YYYY-MM-DD" strings) and UTC timestamps.
//
// Calendar dates (del_date, del_submit_date, etc.) are always handled in the user's
// local timezone. Never build one with toISOString() -- it returns the UTC day, which
// is tomorrow's date during evening hours in US timezones. Never parse one with
// new Date("YYYY-MM-DD") -- it parses as UTC midnight and shifts back a day.
//
// UTC timestamps (the `updated` column) come from the API as ISO 8601 strings and are
// converted to the viewer's local date for display.

// Format a Date (default: now) as a local "YYYY-MM-DD" string.
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Parse a "YYYY-MM-DD" (or ISO datetime) string to a Date at local midnight.
// Date instances pass through unchanged; invalid input returns null.
export const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  if (dateString instanceof Date) return dateString;
  const dateOnly = String(dateString).split("T")[0].split(" ")[0];
  const [year, month, day] = dateOnly.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

// Convert a UTC timestamp from the API to the user's local "YYYY-MM-DD".
// Date-only strings and unparseable values (e.g. "-") pass through unchanged.
// Strings without an explicit offset are treated as UTC.
export const utcToLocalDateString = (utcString) => {
  if (!utcString) return utcString;
  const str = String(utcString);
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  const hasOffset = /([zZ]|[+-]\d{2}:?\d{2}|GMT)$/.test(str);
  const normalized = hasOffset ? str : `${str.replace(" ", "T")}Z`;
  const parsed = new Date(normalized);
  if (isNaN(parsed.getTime())) return str;
  return getLocalDateString(parsed);
};
